import React from "react";
import revampData from "../../data/revampData.json";
import CompanyCarousel from "../../components/CompanyCarousel";

interface Company {
	id: string | number;
	title: string;
	description: string;
	image: string[]; // changed here
	type: string;
}

interface RevampDataShape {
	data: {
		listMarathonTrustedCompany: {
			data: Company[];
		};
	};
}

const HomePartners: React.FC = () => {
	// Cast revampData to our typed shape
	const companies: Company[] = (revampData as RevampDataShape).data.listMarathonTrustedCompany
		.data;

	return (
		<div className="">
			<div className="px-sm-5 font-figtree px-md-3 px-3 text-center pt-5">
				<p className="mb-4 fw-semibold font-sm" style={{ color: "#002E6E" }}>
					{companies[0]?.title || "Trusted by 1000+ Companies & Communities"}
				</p>
				<div className="row logo-container justify-content-center align-items-center company-row">
					<CompanyCarousel />
				</div>
			</div>

			<style jsx>{`
				.partner-logo {
					max-height: 60px;
					max-width: 120px;
					object-fit: contain;
					filter: grayscale(100%);
					transition: filter 0.3s ease;
				}
				.partner-logo:hover {
					filter: grayscale(0%);
				}
				.logo-container {
					max-width: 900px;
					margin: auto;
					width: 100%;
				}
				@media (min-width: 1024px) {
					.company-row {
						display: flex;
						flex-wrap: nowrap;
						justify-content: space-around;
					}
				}
				@media (max-width: 373px) {
					.company-row {
						display: flex;
						flex-wrap: wrap;
						gap: 15px;
						justify-content: space-around;
					}
				}
			`}</style>
		</div>
	);
};

export default HomePartners;
